import client from 'client'
import type {
  CreateTariffTariffPostMutationRequest,
  CreateTariffTariffPostMutationResponse,
  CreateTariffTariffPostQueryParams,
  CreateTariffTariffPost422,
} from '../../types/CreateTariffTariffPost.ts'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from 'client'
import { useMutation } from '@tanstack/react-query'

export const createTariffTariffPostMutationKey = () => [{ url: '/tariff' }] as const

export type CreateTariffTariffPostMutationKey = ReturnType<typeof createTariffTariffPostMutationKey>

/**
 * @summary Create Tariff
 * {@link /tariff}
 */
export async function createTariffTariffPost(
  data: CreateTariffTariffPostMutationRequest,
  params?: CreateTariffTariffPostQueryParams,
  config: Partial<RequestConfig<CreateTariffTariffPostMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<CreateTariffTariffPostMutationResponse, ResponseErrorConfig<CreateTariffTariffPost422>, CreateTariffTariffPostMutationRequest>({
    method: 'POST',
    url: `/tariff`,
    params,
    data,
    ...requestConfig,
  })
  return res
}

/**
 * @summary Create Tariff
 * {@link /tariff}
 */
export function useCreateTariffTariffPost(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateTariffTariffPostMutationResponse>,
      ResponseErrorConfig<CreateTariffTariffPost422>,
      { data: CreateTariffTariffPostMutationRequest; params?: CreateTariffTariffPostQueryParams }
    >
    client?: Partial<RequestConfig<CreateTariffTariffPostMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: mutationOptions, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? createTariffTariffPostMutationKey()

  return useMutation<
    ResponseConfig<CreateTariffTariffPostMutationResponse>,
    ResponseErrorConfig<CreateTariffTariffPost422>,
    { data: CreateTariffTariffPostMutationRequest; params?: CreateTariffTariffPostQueryParams }
  >({
    mutationFn: async ({ data, params }) => {
      return createTariffTariffPost(data, params, config)
    },
    mutationKey,
    ...mutationOptions,
  })
}